module.exports = __webpack_public_path__ + "static/media/l2.02918543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/list/l2.jpg
// module id = 282
// module chunks = 0